module.exports = __webpack_public_path__ + "static/media/office-3.6a7c2c33.jpg";